import React from 'react'
import { Outlet, useLocation, useNavigate } from 'react-router-dom'
import { HiOutlineWallet, HiOutlineArrowsRightLeft } from 'react-icons/hi2'
import { PageHeader } from '../components/ui/PageHeader'
import { Tabs } from '../components/ui/Tabs'

const CreditMaintenance = () => {
  const location = useLocation()
  const navigate = useNavigate()

  const tabs = [
    {
      id: 'balance',
      label: 'Credit balance',
      href: '/admin/credit-maintenance/balance',
      icon: <HiOutlineWallet className="h-4 w-4" />,
    },
    {
      id: 'transactions',
      label: 'Transactions',
      href: '/admin/credit-maintenance/transactions',
      icon: <HiOutlineArrowsRightLeft className="h-4 w-4" />,
    },
  ]

  const activeId = location.pathname.includes('/transactions') ? 'transactions' : 'balance'

  return (
    <div>
      <PageHeader
        title="Credit maintenance"
        subtitle="Manage organisation credit balances and transaction history"
      />
      <Tabs
        tabs={tabs}
        activeId={activeId}
        onChange={(tab) => navigate(tab.href)}
        className="mb-6"
      />
      <Outlet />
    </div>
  )
}

export default CreditMaintenance
